import { request } from "../_helpers/Auth";

const namespace = "/api";

export const getAskValidations = () => {
    return request({
        url: namespace + "/ask_validations",
        method: "get",
    });
};

export const getMyAsk = (status) => {
    return request({
        url: namespace + "/ask_validations/" + status,
        method: "get",
    });
};

export const getAskValidators = (status) => {
    return request({
        url: namespace + "/ask_validators/" + status,
        method: "get",
    });
};

export const validateRequest = (request_id, payload) => {
    return request({
        url: namespace + "/validate_request/" + request_id,
        method: "post",
        data: payload,
    });
};

export const refuseRequest = (request_id, payload) => {
    return request({
        url: namespace + "/refuse_request/" + request_id,
        method: "post",
        data: payload,
    });
};
